import { Json, JsonEntity } from '@homeleite/arch';
import { AdminUser, ControllerUser, ProducerUser, User } from '../users';

export class CurrentInfo implements JsonEntity {
  constructor(public readonly user: User) {}

  get isAdmin() {
    return this.user instanceof AdminUser;
  }

  get isProducer() {
    return this.user instanceof ProducerUser;
  }

  get isController() {
    return this.user instanceof ControllerUser;
  }

  toJson() {
    return Json.to.simple(this, {
      user: this.user.toJson(),
    });
  }
  static fromJson(json: any) {
    return json?.user ? new CurrentInfo(User.fromJson(json.user)) : null;
  }
}
